import store from '@/store';
import { isEmptyVal } from '@/utils';

export const getPartnershipParams = () => {
  const getters = store.getters;
  /** @type {PartnerReferBean} */
  const partnerRefer = getters.partnerRefer;

  if (isEmptyVal(partnerRefer)) return;

  /**
   * if distributeDependPlanList field not config in op, we need check eligible for partner, eligible means send partner params, false means not send partner params
   * distributionDependPlanList is empty means not force to send partner code (only eligible)
   * distributionDependPlanList is not empty means force to send partner code (both eligible/ineligible)
   * @type {boolean}
   */
  const forceSendPartnerCode = isEmptyVal(partnerRefer.rules?.distributionDependPlanList) === false;

  const baseInfo = {
    jointsaleCode: partnerRefer.jointsaleCode,
    referralCode: partnerRefer.referralCode,
  };

  // regardless of whether the verification is successful or not partner, the order needs to be sent jointsaleCode, referralCode
  if (forceSendPartnerCode) {
    return baseInfo;
  }

  if (getters.eligiblePartnerReferOffer) {
    return baseInfo;
  }
};
